module.exports = __webpack_public_path__ + "static/pubconfwin-5529547894861d770e84fde6bb70bdf2.jpeg";